<div>

	<div class="text-left">
		<h3>パスワード変更</h3>
	</div>
	<br>
	<form method="post" [formGroup]="form" (ngSubmit)="submit()" class="form-inline">

		<div class="control-group">
			<label for="password">新しいパスワード</label>
			<div class="controls">
				<input type="text" name="password"  formControlName="password" class="form-control">
			</div>
		</div>
		<br>
		<div class="control-group">
			<label for="password_confirm">新しいパスワード確認</label>
			<div class="controls">
				<input type="text" name="password_confirm"  formControlName="password_confirm" class="form-control">
			</div>
		</div>
		<div class="control-group ">
			
		</div>
		<br>
		<span class="password-notice">*初期パスワードと同じ内容での設定は不可。</span><br>
		<span class="password-notice">英文字と数字を含む、８桁のパスワードを入力してください。</span><br>
		<button type="submit" [disabled]="!form.valid" name="button" class="btn btn-default">送信</button>
		<!-- <a href="/auth/signup" class="btn btn-default">Sign up</a> -->
	</form>

</div>